import { Injectable } from '@angular/core';
import { ObservableQuery, OperationVariables } from '@apollo/client/core';
import { QueryInfo } from '@apollo/client/core/QueryInfo';
import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class QueryReloaderService {
  constructor(private apollo: Apollo) {}

  reloadQueriesLike(re: RegExp) {
    this.eachQuery((query) => {
      if (re.test(query.queryName)) {
        query.refetch();
      }
    });
  }

  removeFromCache(re: RegExp) {
    const cache = this.apollo.client.cache;
    const data = cache['data'];
    const keys = Object.keys(data.data);
    for (const key of keys) {
      if (re.test(key)) {
        delete data.data[key];
      }
    }
  }

  // reload(typename: string, id?: any) {
  //   let recursor: Recursor;
  //   if (id) {
  //     recursor = new RecordRecursor(typename, id);
  //   } else {
  //     recursor = new TypeRecursor(typename);
  //   }
  //   this.eachQuery((observableQuery) => {
  //     const result = observableQuery.getCurrentResult();
  //     const shouldReload = recursor.recurse(result.data);
  //     if (shouldReload) {
  //       observableQuery.refetch();
  //     }
  //   });
  // }

  eachQuery<T>(fn: (query: ObservableQuery<T, OperationVariables>) => void) {
    this.queries().forEach(({ observableQuery }) => {
      if (observableQuery) {
        fn(observableQuery);
      }
    });
  }

  private queries(): Map<string, QueryInfo> {
    return this.apollo.client['queryManager']['queries'] as Map<string, QueryInfo>;
  }
}
